import { AnimatedSection } from "@/components/common/AnimatedSection";
import { Shield, Clock, Award, Headphones, Globe, Heart } from "lucide-react";

const reasons = [
  {
    icon: Heart,
    title: "Personalized Service",
    description: "Every itinerary is tailored to your preferences, style, and budget — not a one-size-fits-all package.",
  },
  {
    icon: Shield,
    title: "Best Price Guarantee",
    description: "Competitive pricing with transparent, upfront quotes. No hidden fees, ever.",
  },
  {
    icon: Headphones,
    title: "24/7 Expert Support",
    description: "Our travel experts are available around the clock — before, during, and after your trip.",
  },
  {
    icon: Award,
    title: "Trusted by Thousands",
    description: "Over 50,000 happy travelers and 4.9-star ratings back our commitment to excellence.",
  },
  {
    icon: Globe,
    title: "Global Reach",
    description: "Access to 100+ destinations across 6 continents, with local knowledge at every stop.",
  },
  {
    icon: Clock,
    title: "Fast Response",
    description: "Get a personalized, detailed quote within 24 hours of submitting your request.",
  },
];

export const WhyChooseUs = () => {
  return (
    <section className="bg-white section-padding" data-testid="why-choose-us">
      <div className="container-wide px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto mb-12">
            <p className="overline mb-3">Why Tripsyfy</p>
            <h2 className="heading-lg text-primary mb-4">Why Travelers Choose Us</h2>
            <p className="text-base text-muted-foreground leading-relaxed">
              We don't just plan trips — we craft experiences that create lasting memories and lifelong travel stories.
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {reasons.map((reason, i) => (
            <AnimatedSection key={reason.title} delay={i * 0.07}>
              <div
                className="group bg-white border border-border/60 rounded-xl p-6 hover:border-accent/20 hover:shadow-card transition-[box-shadow,border-color] duration-200 flex flex-col h-full"
                data-testid={`reason-${i + 1}`}
              >
                <div className="h-12 w-12 rounded-2xl bg-surface-soft flex items-center justify-center mb-4 group-hover:bg-accent/10 transition-colors duration-200">
                  <reason.icon className="h-5 w-5 text-accent" />
                </div>
                <h3 className="text-base font-bold text-primary mb-2">{reason.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{reason.description}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};
